/**
 * Lets non-React code (BaseApiService) tell the SiteGate provider that the gate cookie is no longer
 * valid (a 511 response mid-session), so the password screen can be shown again. Mirrors the role
 * apiStatusManager plays for maintenance (503).
 */
class SiteGateManager {
    private listeners: Set<() => void> = new Set();

    /** Subscribe to "gate re-locked" events. Returns an unsubscribe function. */
    subscribe(callback: () => void): () => void {
        this.listeners.add(callback);
        return () => {
            this.listeners.delete(callback);
        };
    }

    /** Notify subscribers that the gate needs to be satisfied again (a request returned 511). */
    notifyLocked(): void {
        this.listeners.forEach(callback => callback());
    }
}

export const siteGateManager = new SiteGateManager();

/** HTTP status the API uses to signal the sitewide gate is not satisfied. */
export const SITE_GATE_STATUS = 511;
